import { render, staticRenderFns } from "./Parthers.vue?vue&type=template&id=4c669919"
import script from "./Parthers.vue?vue&type=script&lang=js"
export * from "./Parthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports